import { createAction } from "@ngrx/store";

export const ResetState = createAction('[Global] Reset State');